import { ConfigFieldType, TextInputFieldData } from 'adapter/in/common/form/types';
import useTextContainer from 'adapter/in/common/form/Text/useTextContainer';
import FormColorPicker from 'adapter/in/common/components/ColorPicker';
import { validationIsHexColor } from 'adapter/in/common/utils/validation';
import i18n from 'asset/translation';
import React, { ReactElement } from 'react';

type ColorPickerInputContainerProps = {
    name: string;
    label: string;
    configType: ConfigFieldType;
    dataDependsOn?: string[];
    defaultValue?: TextInputFieldData;
    showInput?: boolean;
};

const ColorPickerInputContainer = ({
    name,
    label,
    configType,
    dataDependsOn,
    defaultValue,
    showInput,
}: ColorPickerInputContainerProps): ReactElement => {
    const { handleOnChange, invalid, value: fieldValue } = useTextContainer(
        name,
        configType,
        { required: true, validate: { color: validationIsHexColor } },
        dataDependsOn,
        defaultValue
    );
    return (
        <FormColorPicker
            name={name}
            label={label}
            onChange={handleOnChange}
            showInput={showInput || false}
            isLoading={false}
            error={invalid}
            errorMessage={i18n.t('widgets.errorInvalidColor')}
            dataTestId='color-picker'
            initialColor={defaultValue?.getInitialValue() || '#FFFFFF'}
            value={fieldValue.value}
        />
    );
};

export default ColorPickerInputContainer;
